import React from 'react'
import PropTypes from 'prop-types'
import ContactForm from '../../../components/ContentContactForm'

const ContactWidget = ({
  title,
  heading,
  text,
  theme,
  registrationRequired,
  phoneNumberRequired,
  locations = [],
  customerEmailType,
  internalEmailType,
  showPostcode,
  showRegistration,
  additionalInfoRequired,
  additionalInfoLabel,
  locationLabel,
  selectedLocations = [],
  enquiryType,
  showEnquiryType
}) => {
  const backgroundColours = {
    white: '#FFFFFF',
    light: '',
    dark: '#4A5567',
    blue: '#1E4F67'
  }

  let filteredLocations = []
  const allSelected = selectedLocations.some((location) => location === 'all')

  if (selectedLocations.length) {
    filteredLocations = allSelected
      ? locations.map(({ shortName }) => shortName)
      : locations
          .filter((location) => selectedLocations.includes(location._id))
          .map(({ shortName }) => shortName)
  }

  return (
    <ContactForm
      heading={heading}
      title={title}
      bg={backgroundColours[theme]}
      registrationRequired={registrationRequired}
      phoneNumberRequired={phoneNumberRequired}
      locations={filteredLocations}
      customerEmailType={customerEmailType}
      locationLabel={locationLabel}
      locationRequired={!!filteredLocations.length}
      internalEmailType={internalEmailType}
      showPostcode={showPostcode}
      showRegistrationField={showRegistration}
      showEnquiryType={showEnquiryType}
      additionalInfoRequired={additionalInfoRequired}
      additionalInfoLabel={additionalInfoLabel}
      enquiryType={enquiryType}
    >
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </ContactForm>
  )
}

ContactWidget.propTypes = {
  title: PropTypes.string.isRequired,
  heading: PropTypes.string,
  text: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['white', 'light', 'dark', 'blue']).isRequired,
  registrationRequired: PropTypes.bool,
  phoneNumberRequired: PropTypes.bool,
  customerEmailType: PropTypes.string,
  locations: PropTypes.array,
  selectedLocations: PropTypes.array,
  locationLabel: PropTypes.string,
  additionalInfoLabel: PropTypes.string.isRequired,
  internalEmailType: PropTypes.string.isRequired,
  showPostcode: PropTypes.bool,
  showRegistration: PropTypes.bool,
  additionalInfoRequired: PropTypes.bool,
  enquiryType: PropTypes.string,
  showEnquiryType: PropTypes.bool
}

export default ContactWidget
